<template>
  <div
    class="flex h-[292px] w-[258px] animate-pulse flex-col justify-center rounded-md border border-divider bg-gray-100 shadow-md md:w-[353px] lg:w-[228px] xl:h-[352px] xl:w-[336px]"
  />
</template>
